export interface Special {
  id: string;
  title: string;
  subtitle: string;
  intro: string;
  cover: string;
  movieIds: string[];
  reason: string;
  date: string;
}

export const specials: Special[] = [
  {
    id: "s001",
    title: "年度最佳电影推荐",
    subtitle: "那些值得你走进影院的十部作品",
    intro:
      "这一年，我们看过无数光影。真正留下来的，往往是那些关于孤独、告别与和解的故事。这份片单不分先后，只谈感受。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20collage%20of%20glowing%20film%20frames%20floating%20in%20deep%20blue%20space%20with%20warm%20orange%20light%20leaks%2C%20artistic%20movie%20festival%20key%20visual%2C%20high%20detail&width=1600&height=900&seq=fly-special-001&orientation=landscape",
    movieIds: ["m001", "m002", "m003", "m005", "m006"],
    reason:
      "这些作品风格各异，却都在认真地讲述一个人如何面对自己的内心。它们不靠宏大场面取胜，而是用克制与真诚打动观众。",
    date: "2026-10-01",
  },
  {
    id: "s002",
    title: "热播剧集盘点",
    subtitle: "这个秋天，值得熬夜追完的剧",
    intro:
      "当深夜来临，总有一部剧陪着你。我们为你挑选了当下讨论度最高的几部热播剧集，从刑侦到家庭，从奇幻到治愈。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20television%20screens%20glowing%20in%20a%20dark%20room%20with%20deep%20blue%20and%20warm%20orange%20light%2C%20cinematic%20artistic%20key%20visual%2C%20high%20detail&width=1600&height=900&seq=fly-special-002&orientation=landscape",
    movieIds: ["t001", "t002", "t003", "t006", "t007"],
    reason:
      "追剧的乐趣在于陪伴。这几部剧集各自构建了完整的世界，让人愿意一集接一集地待在里面，不愿离开。",
    date: "2026-09-26",
  },
  {
    id: "s003",
    title: "治愈系片单",
    subtitle: "当你需要一点温柔的时候",
    intro:
      "不是所有故事都需要惊心动魄。有时候，一碗热汤、一段旅途、一句迟到的话，就足以让人重新出发。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cozy%20evening%20window%20with%20soft%20deep%20blue%20outside%20and%20orange%20lamplight%20inside%2C%20cinematic%20serene%20artistic%20key%20visual%2C%20high%20detail&width=1600&height=900&seq=fly-special-003&orientation=landscape",
    movieIds: ["m004", "m007", "t004", "t005", "t006"],
    reason:
      "把这几部作品留在一个疲惫的夜晚播放。它们不会催促你振作，只会安静地陪着你，直到情绪慢慢缓过来。",
    date: "2026-09-15",
  },
];